import CardBrandFit from './CardBrandFit';
import './CardBrandFit.scss';

export default CardBrandFit;
